import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法;解决重复点击同一个路由报错问题
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
};

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard'  //首页默认跳转到IndexHouse
    },
    // {
    //   path: '/index',
    //   name: 'index',
      // redirect: '/index/house',
      // component: () => import('@/views/index/Index'),
      // children: [
      //   {
      //     path: 'house',
      //     name: 'house',
      //     component: () => import('@/views/index/indexHouse/IndexHouse'),
      //   },
      //   {
      //     path: 'process',
      //     name: 'process',
      //     component: () => import('@/views/index/process/Process')
      //     // component: () => import('@/views/index/Index'),
      //   }
      // ]
      // component: () => import('@/views/index/Index'),
    // },

     {
      path:'/home',
      name:'Home',
      component:()=>import('@/views/home/Home'),
       meta: {title: '自述文件'},
       children: [
         {
           path: '/dashboard',
           component: () => import('@/views/index/Index'),
           meta: {title: '系统首页'}
         },
         {
           path:'/search',
           name:'Search',
           component:()=>import('@/views/search/Search'),
           meta: {title: '订单查询'}
         },
         {
           path:'/batch_template',
           name:'BatchTemplate',
           component:()=>import('@/views/email/BatchTemplate'),
           meta: {title: '批量邮件'}
         },
         {
           path:'/disputes',
           name:'Dispute',
           component:()=>import('@/views/disputes/Disputes'),
           meta: {title: '调解中心'}
         },
         {
           path:'/preprocess_list',
           component:()=>import('@/views/disputes/PreprocessList'),
           meta: {title: '预处理中心'}
         },
         {
           path: '/shop',
           component: () => import('@/views/shop/Index'),
           meta: {title: '店铺'}
         },
         {
           path: '/payment',
           component: () => import('@/views/payment/Index'),
           meta: {title: 'Paypal'}
         },
         {
           path: '/chanpass',
           component: () => import('@/views/extra/Chanpass'),
           meta: {title: '密码修改'}
         },
         {
           path: '/permissions',
           component: () => import('@/views/roles/Permissions'),
           meta: {title: '权限'}
         },
         {
           path: '/role',
           component: () => import('@/views/roles/Role'),
           meta: {title: '角色'}
         },
         {
           path: '/users',
           component: () => import('@/views/roles/Users'),
           meta: {title: '用户管理'}
         },
         {
           path: '/menus',
           component: () => import('@/views/roles/Menus'),
           meta: {title: '菜单管理'}
         },
         {
           path: '/template',
           component: () => import('@/views/reply_template/Index'),
           meta: {title: '回复模板'}
         },
         {
           path: '/ai-recognition',
           component: () => import('@/views/tickets/AIRecognition'),
           meta: {title: 'AI识别结果'}
         }
       ]
    },

    /*{
      path:'/search',
      name:'Search',
      component:()=>import('@/views/search/Search')

    },*/
    /*{
      path:'/disputes',
      name:'Dispute',
      component:()=>import('@/views/disputes/Disputes')

    },*/
    {
      path:'/login',
      name:'Login',
      component:()=>import('@/views/login/login')

    },
    /*{
      path: '/register',
      name: 'Register',
      component: () => import('@/views/register/Register')
    },*/

  ]
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register') {
    next();
  } else {
    let token = localStorage.getItem('access_token');
    // console.log(token)
    if (token === null || token === '') {
      // 修改了跳转到主页
      next('/login');
    } else {
      next();
    }
  }
});
export default router
